import React, { useRef, useEffect } from "react";

import Input from "../../input";
import { useTable } from "../context";
import { isFunction } from "../utils";
import { toggleSelectAll, allRowsSelected } from "../actions";

const SelectAllCheckbox = () => {
  const {
    selectedRows,
    disabledRows,
    uniqueDataKey,
    data,
    fireAction,
    controlSelection,
    onSelectAll,
    paginationEnabled
  } = useTable();

  const totalEnabledSelected = selectedRows.filter(
    r => !disabledRows.includes(r)
  ).length;
  const totalEnabledRows = data.filter(
    row => !disabledRows.includes(row[uniqueDataKey])
  ).length;
  let isChecked =
    totalEnabledSelected >= totalEnabledRows && totalEnabledRows > 0;
  let indeterminate =
    totalEnabledSelected > 0 && totalEnabledSelected !== totalEnabledRows;
  const checkbox = useRef(null);
  if (paginationEnabled && !controlSelection) {
    const allRowIds = data ? data.map(obj => obj[uniqueDataKey]) : [];
    const currentRows = selectedRows.filter(rowId => allRowIds.includes(rowId));
    /* When a selectedrow is deleted or data is changed: in both cases we need to reset checkbox */
    if (currentRows.length === 0) {
      isChecked = false;
      indeterminate = false;
    }
  }

  useEffect(() => {
    if (checkbox.current) {
      checkbox.current.indeterminate = indeterminate;
    }
    if (indeterminate) {
      fireAction(allRowsSelected(false));
    }
  }, [checkbox, indeterminate, selectedRows, fireAction]);

  return (
    <Input
      innerRef={checkbox}
      type="checkbox"
      checked={isChecked}
      className="row-selection-input orion-data-grid--select-all"
      onChange={e => {
        /* istanbul ignore if */ // will open this when come to test actions

        if (!controlSelection) {
          fireAction(toggleSelectAll(indeterminate ? false : e.target.checked));
        }

        /* istanbul ignore else */
        if (isFunction(onSelectAll)) {
          onSelectAll(e.target.checked);
        }
      }}
    />
  );
};

export default SelectAllCheckbox;
